import {
  MaterialLabourScheduleStateTypes,
  MaterialLabourScheduleActionTypes,
} from "./MaterialLabourSchedule.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: MaterialLabourScheduleStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchAllList: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const MaterialLabourScheduleReducer = (
  state: MaterialLabourScheduleStateTypes = INITIAL_STATE,
  action: any
): MaterialLabourScheduleStateTypes => {
  switch (action.type) {
    case MaterialLabourScheduleActionTypes.FETCH_ALL_MATERIAL_LABOUR_SCHEDULE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialLabourScheduleActionTypes.FETCH_ALL_MATERIAL_LABOUR_SCHEDULE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case MaterialLabourScheduleActionTypes.FETCH_ALL_MATERIAL_LABOUR_SCHEDULE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialLabourScheduleActionTypes.FETCH_ALL_MATERIAL_LABOUR_SCHEDULE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -------------

    case MaterialLabourScheduleActionTypes.FETCH_ALL_LIST_MATERIAL_LABOUR_SCHEDULE:
      return {
        ...state,
        fetchAllList: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialLabourScheduleActionTypes.FETCH_ALL_LIST_MATERIAL_LABOUR_SCHEDULE_RESET:
      return {
        ...state,
        fetchAllList: resetApiCallState([]),
      };
    case MaterialLabourScheduleActionTypes.FETCH_ALL_LIST_MATERIAL_LABOUR_SCHEDULE_FAILURE:
      return {
        ...state,
        fetchAllList: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialLabourScheduleActionTypes.FETCH_ALL_LIST_MATERIAL_LABOUR_SCHEDULE_SUCCESS:
      return {
        ...state,
        fetchAllList: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -------------

    case MaterialLabourScheduleActionTypes.FETCH_ONE_MATERIAL_LABOUR_SCHEDULE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case MaterialLabourScheduleActionTypes.FETCH_ONE_MATERIAL_LABOUR_SCHEDULE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case MaterialLabourScheduleActionTypes.FETCH_ONE_MATERIAL_LABOUR_SCHEDULE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case MaterialLabourScheduleActionTypes.FETCH_ONE_MATERIAL_LABOUR_SCHEDULE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default MaterialLabourScheduleReducer;
